/* =====================================================================
   SIALBÉ V2 · JS mínimo para secciones sv2-*
   1) Toggle Mañana / Noche del ritual (botones con aria-pressed)
   2) "Añadir +" en tarjetas: añade con /cart/add.js y abre el mini cart
      de Eurus. Sin JS, el formulario hace POST normal a /cart/add.
   3) Diario: botón "Copiar enlace" ([data-sv2-copy]).
   ===================================================================== */
(function () {
  if (window.__sv2Loaded) return;
  window.__sv2Loaded = true;

  /* === 1. TOGGLE DEL RITUAL === */
  function initToggles(root) {
    (root || document).querySelectorAll('[data-sv2-toggle]').forEach(function (group) {
      if (group.dataset.sv2Ready) return;
      group.dataset.sv2Ready = '1';
      var scope = group.closest('[data-sv2-ritual]');
      if (!scope) return;
      group.querySelectorAll('button[data-sv2-moment]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var m = btn.getAttribute('data-sv2-moment');
          group.querySelectorAll('button[data-sv2-moment]').forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          scope.querySelectorAll('[data-sv2-steps]').forEach(function (list) {
            list.hidden = list.getAttribute('data-sv2-steps') !== m;
          });
        });
      });
    });
  }

  /* === 2. AÑADIR A LA BOLSA === */
  function refreshEurusCart() {
    try {
      if (window.Alpine && Alpine.store('xMiniCart')) {
        var mc = Alpine.store('xMiniCart');
        if (typeof mc.reLoad === 'function') mc.reLoad();
        if (typeof mc.openCart === 'function') setTimeout(function () { mc.openCart(); }, 350);
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      return true;
    } catch (e) { return false; }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-sv2-add]')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('[data-sv2-msg]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Error');
        if (btn) btn.textContent = 'Añadido';
        if (msg) msg.textContent = 'Se añadió a tu bolsa.';
        if (!refreshEurusCart()) window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        setTimeout(function () { if (btn) { btn.textContent = label; btn.disabled = false; } if (msg) msg.textContent = ''; }, 2400);
      })
      .catch(function (err) {
        if (btn) { btn.textContent = label; btn.disabled = false; }
        if (msg) msg.textContent = err && err.message ? err.message : 'No se pudo añadir. Intenta de nuevo.';
      });
  });

  /* === 3. DIARIO · COPIAR ENLACE (botón [data-sv2-copy]) === */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-sv2-copy]') : null;
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-sv2-copy') || window.location.href;
    var msg = btn.parentNode ? btn.parentNode.querySelector('[data-sv2-copy-msg]') : null;
    function done(ok) {
      if (msg) {
        msg.textContent = ok ? 'Enlace copiado' : url;
        setTimeout(function () { msg.textContent = ''; }, ok ? 2400 : 8000);
      }
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); });
    } else {
      try {
        var ta = document.createElement('textarea');
        ta.value = url; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        done(ok);
      } catch (err) { done(false); }
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initToggles(); });
  else initToggles();
  document.addEventListener('shopify:section:load', function (e) { initToggles(e.target); });
})();

/* === V8 · VIDEOS: que se reproduzcan solos también en el celular === */
(function () {
  function arrancar(v) {
    if (!v || v.dataset.v8) return;
    v.dataset.v8 = '1';
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.setAttribute('preload', 'auto');
    function go() { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
    go();
    v.addEventListener('loadeddata', go);
    v.addEventListener('canplay', go);
    v.addEventListener('pause', function () { if (!document.hidden) setTimeout(go, 300); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { if (e[0].isIntersecting) go(); }, { threshold: 0.2 }).observe(v);
    }
    /* Si el iPhone bloquea el autoplay (modo ahorro de batería), arranca con el primer toque o scroll */
    ['touchstart', 'scroll', 'click'].forEach(function (ev) { window.addEventListener(ev, go, { passive: true, once: true }); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) go(); });
  }
  function init() { document.querySelectorAll('[data-v4-vid], [data-pf-vid]').forEach(arrancar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
/* === FIN V8 === */
